import { app } from "js/namespaces";
import { isPPTAddin } from "js/config";
import {
    ShowConfirmationDialog,
    ShowDialog,
    ShowErrorDialog,
    ShowWarningDialog
} from "js/react/components/Dialogs/BaseDialog";
import { FeatureType } from "js/core/models/features";
import { LockedSharedSlideDialog, TeamSlideDialog } from "js/editor/TeamResources/TeamSlideDialog";

export async function handleEditSharedSlide() {
    if (isPPTAddin) {
        ShowWarningDialog({
            title: "Sorry, this Team Slide cannot be edited.",
            message: "Team Slides cannot be edited from PowerPoint."
        });
        return;
    }

    const workspaceId = app.currentCanvas.dataModel.presentation.getWorkspaceId();
    if (app.user.features.isFeatureEnabled(FeatureType.EDIT_LIBRARY_ITEMS, workspaceId) && app.currentCanvas.slide.isLibrarySlideInCurrentUserOrg()) {
        if (await ShowConfirmationDialog({
            title: "Do you want to edit this Team Slide?",
            message: "WARNING: Any changes you make to a Team Slide will be applied to all presentations that contain this slide."
        })) {
            ShowDialog(TeamSlideDialog, {
                libraryItemId: app.currentCanvas.slide.get("libraryItemId"),
                openFromLibrary: false
            });
        }
    } else if (app.currentCanvas.slide.isLibrarySlideInCurrentUserOrg()) {
        // if the user is a member and the team slide is in their org, let them know they need to contact an owner or librarian
        ShowDialog(LockedSharedSlideDialog, {
            organizationId: app.currentCanvas.dataModel.presentation.get("orgId")
        });
    } else {
        // otherwise let them know they cant
        ShowErrorDialog({
            title: "Sorry, this Team Slide is not editable by you.",
            message: "This Team Slide is not in your workspace and you don't have permissions to edit it."
        });
    }
}
